import { render, staticRenderFns } from "./notice-event-detail.vue?vue&type=template&id=07424870&scoped=true&"
import script from "./notice-event-detail.vue?vue&type=script&lang=js&"
export * from "./notice-event-detail.vue?vue&type=script&lang=js&"
import style0 from "./notice-event-detail.vue?vue&type=style&index=0&id=07424870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07424870",
  null
  
)

export default component.exports